import { useLayoutEffect, useRef, type ReactNode } from 'react';
import { Body1, Title3 } from '@fluentui/react-components';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function PageHeader({ title, description, action }: PageHeaderProps) {
  const ref = useRef<HTMLDivElement>(null);

  // Eigene Höhe als CSS-Variable veröffentlichen, damit andere sticky-Elemente
  // (Auswahlliste, Reiter) genau darunter andocken.
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => document.documentElement.style.setProperty('--page-header-height', `${el.offsetHeight}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="app-page-header" ref={ref}>
      <div className="app-page-header-row">
        <Title3>{title}</Title3>
        {action}
      </div>
      {description ? (
        <Body1 className="app-page-header-desc">{description}</Body1>
      ) : null}
    </div>
  );
}
